module.exports = __webpack_public_path__ + "static/img/cont57 (6).e654007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (6).jpg
// module id = RuXf
// module chunks = 0